import { Divider, Flex, Space } from 'antd'
import { createStyles } from 'antd-style'

import { DownloadButton } from './DownloadButton'
import { EnableButton } from './EnableButton'
import { PreviewButton } from './PreviewButton'
import { SubmitButton } from './SubmitButton'
import { TemplateNameInput } from './TemplateNameInput'

const useStyles = createStyles(({ token }) => ({
  topbar: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    alignItems: 'center',
    paddingBlock: token.paddingSM,
    paddingInline: token.paddingMD,
    borderBlockEnd: `1px solid ${token.colorBorderSecondary}`
  },
  input: {
    width: 'auto',
    justifySelf: 'center'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}))

export const Topbar = () => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.topbar, 'contract-designer-topbar')}>
      <span>合同设计器</span>
      <TemplateNameInput className={styles.input} />
      <Flex align='center' gap={12} justify='end'>
        <Space size={0} separator={<Divider orientation='vertical' />}>
          <EnableButton />
          <DownloadButton />
        </Space>
        <PreviewButton />
        <SubmitButton />
      </Flex>
    </div>
  )
}
